import React from 'react';

/*
 * PROD-7828 — one issue row's Session cell: date/time links to the Hridaya session page in a new tab,
 * the student's name muted underneath (nothing when the API hasn't sent one yet — never falls back to
 * the uuid); a month-level issue (session_id 0) has no session to link to. Shared by the monthly issue
 * list and the Daily report's per-line drill-down so the two never render it differently.
 */
const SessionCell = ({ row }) =>
  row.session_id === 0 ? (
    <span>{row.session_start_text}</span>
  ) : (
    <div>
      <a
        className="tp-link"
        href={`/sessiondetails?id=${row.session_uuid}`}
        target="_blank"
        rel="noopener noreferrer"
        title={row.session_uuid}
      >
        {row.session_start_text}
      </a>
      {row.student_name ? <div className="tp-card-field-label">{row.student_name}</div> : null}
    </div>
  );

export default SessionCell;
